import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Editor, { TABLE_CELL_COMPONENT, FORM_FIELD_COMPONENT, NOT_APPLICABLE } from '../Editor';
import './ArrayEditor.scss';

const printObject = (o) => {
  if (!o) {
    return '';
  }
  const s = Object.keys(o).map(p => `${p}=${o[p]}`).join(',');
  return `{${s}}`;
};

class ArrayComponent extends React.PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.arrayOf(PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ])).isRequired,
    editing: PropTypes.bool,
    label: PropTypes.string,
    description: PropTypes.string,
    error: PropTypes.string,
    readOnly: PropTypes.bool,
    form: PropTypes.bool,
    property: PropTypes.shape({
      vertical: PropTypes.bool,
    }),
  }

  static defaultProps = {
    editing: false,
    error: null,
    readOnly: false,
    label: null,
    description: null,
    form: false,
    property: {},
  };

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (event) => {
    const { onChange } = this.props;
    if (onChange) {
      const array = event.target.value.split(',');
      onChange(array.map(s => s.trim()));
    }
  };

  render() {
    const {
      value,
      editing,
      error,
      label,
      readOnly,
      description,
      property,
      form,
    } = this.props;
    const editingValue = (editing || form) && (value && value.length ? value.join(',') : '');
    function getCellKey(cell, i) {
      return `${i}`;
    }
    return (
      <div className="tuc-textfield-editor">
        {editing && (
          <TextField
            error={!!error}
            label={error || label}
            value={editingValue}
            margin="dense"
            onChange={this.handleChange}
            disabled={readOnly}
          />
        )}
        {!editing && (
          form ? (
            <TextField
              label={label}
              value={editingValue}
              margin="normal"
              InputProps={{
                readOnly: true,
              }}
              helperText={description}
              fullWidth
            />
          ) : (
            <div className={classnames('tuc-array-ctnr', property.vertical && 'tuc-array-ctnr-column')}>
              {value && value.map((cell, i) => {
                return (
                  <Typography className="tuc-array-cell" key={getCellKey(cell, i)} variant="body2">
                    {typeof cell === 'string' && cell}
                    {typeof cell === 'number' && cell}
                    {typeof cell === 'object' && printObject(cell)}
                  </Typography>
                );
              })}
            </div>
          )
        )}
      </div>
    );
  }
}

export default class ArrayEditor extends Editor {
  constructor(name, components) {
    super(name || 'array', Object.assign({}, {
      [TABLE_CELL_COMPONENT]: [ArrayComponent, ArrayComponent],
      [FORM_FIELD_COMPONENT]: [ArrayComponent],
    }, components));
  }

  formatValue(array) {
    return array === undefined
      ? NOT_APPLICABLE
      : array.map((v) => {
        switch (typeof v) {
          case 'string':
          case 'number': return v;
          default: return printObject(v);
        }
      }).join(',');
  }
}
